import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageModal } from '../../components/modals/MessageModal';
export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsMessageModalOpen(true);
  };
  return <div data-testid="forgot-password-page" className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933]" data-id="element-2225">
      <header data-testid="forgot-password-header" className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-2226">
        <Link data-testid="forgot-password-logo-link" to="/" className="flex items-center gap-2" data-id="element-2227">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-2228"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-2229">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main data-testid="forgot-password-main" className="max-w-md mx-auto px-4 py-12" data-id="element-2230">
        <div data-testid="forgot-password-card" className="bg-white border border-gray-300 p-8 shadow-sm" data-id="element-2231">
          <h1 data-testid="forgot-password-title" className="text-2xl font-bold mb-2" data-id="element-2232">
            Reset Password
          </h1>
          <p data-testid="forgot-password-subtitle" className="text-sm text-gray-500 mb-6" data-id="element-2233">
            Enter your email address and we'll send you a reset link
          </p>

          <form data-testid="forgot-password-form" onSubmit={handleSubmit} className="space-y-4" data-id="element-2234">
            <div data-id="element-2235">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-2236">
                Email Address
              </label>
              <input data-testid="forgot-password-email-input" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2237" />
            </div>

            <button data-testid="forgot-password-submit-btn" type="submit" className="w-full py-3 bg-[#1f2933] text-white font-bold hover:bg-gray-800" data-id="element-2238">
              Send Reset Link
            </button>
          </form>

          <p data-testid="forgot-password-signin-link" className="mt-6 text-center text-sm text-gray-600" data-id="element-2239">
            Remember your password?{' '}
            <Link to="/auth/signin" className="text-blue-600 font-bold hover:underline" data-id="element-2240">
              Sign In
            </Link>
          </p>
        </div>
      </main>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Reset Link Sent" message={`Password reset instructions have been sent to ${email}. Please check your inbox and spam folder.`} type="success" data-id="element-2241" />
    </div>;
}